import commonStyle from "../../CommonStyles.module.css";
import { Dropdown } from "primereact/dropdown";
import { convertSumWithLatestCurrencyRate, formatCurrency, formatShortDate, systemCurrencies } from "../../../../Utils/Utils";
import { useFormik } from "formik";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { numberEditor, priceEditor, textEditor } from "../../../../Utils/TableEditors";
import { Toolbar } from "primereact/toolbar";
import useApi from "../../../../Utils/BackendClient";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import CalendarInput from "../../../UIElements/Inputs/CalendarInput";
import ActNumberWithAutogenerateInput from "../../../UIElements/Inputs/ActNumberWithAutogenerateInput";
import DiscountInput from "../../../UIElements/Inputs/DiscountInput";

const ExternalActDetailsContent = ({ ctx, orderData, toast, isMobile }) => {

    const { createExternalActFromOrder } = useApi();

    const formik = useFormik({
        initialValues: {
            order_id: orderData.order_id,
            partner_id: orderData?.partner_id,
            partner_is_payment_receiver: false,
            act_number_autogenerate: true,
            comission_type: "%",
            discounts: [],
            commission: [],
            products: orderData?.products ?? [],
            services: orderData?.services ?? [],
            commission_percent: 0,
            act_number: "",
            act_date: new Date(),
            pay_due_date: new Date(),
        },
        validate: values => {
            const errors = {};

            if(!values.partner_id){
                errors.partner_id = "Виберіть партнера зі списку"
            }

            return errors;
        },
        onSubmit: async (values) => {

            const payload = {
                ...values,
                act_date: formatShortDate(values.act_date),
                pay_due_date: formatShortDate(values.pay_due_date),
                commission_percent: values.commission_percent !== 0 ? values.commission_percent / 100 : values.commission_percent,
                commission: values.commission.length > 0 ? values.commission : [],
                products: values.products.map(product => product.product_id),
                services: values.services.map(service => service.service_id)
            };

            const response = await createExternalActFromOrder(payload);

            if(response.status === 201){
                toast.current.show({ severity: "success", summary: "Успіх", detail: `Партнерський акт № ${response.data.id} створено}`, life: 3000 });
            }
            else{
                console.log(response.error);
                DisplayErrors(response.error, toast);
            }
        }
    });

    const CheckAndChangeComissionType = (type) => {
        if (type === "%") {
            formik.setFieldValue("comission_type", type);
        }
        else {
            if (formik.values.commission.length === 0) {
                let updatedComissionList = formik.values.commission;

                const newComission = {
                    currency: "UAH",
                    amount: 0
                }

                updatedComissionList = [...updatedComissionList, newComission];

                formik.setFieldValue("commission", updatedComissionList);
            }

            formik.setFieldValue("comission_type", type);
        }
    }

    const handleParameterChange = (index, value, parameter, array) => {
        const obj = [...formik.values[array]];
        obj[index][parameter] = value;
        formik.setFieldValue(array, obj);
    };

    const handleCellEditComplete = (e, arrayName) => {
        const rowIndex = e.index ?? e.rowIndex;

        const updated = [...formik.values[arrayName]];
        updated[rowIndex] = {
            ...updated[rowIndex],
            [e.field]: e.newValue
        };

        formik.setFieldValue(arrayName, updated);
    };

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className="text-xl text-900 font-bold">{tablename}</span>
            </div>
        );
    }

    const actToolbarLeftTemplate = () => {
        return <h3>Cтворення партнерського акту</h3>;
    };

    const actToolbarRightTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="Зберегти" severity="success" className={commonStyle.addButton} type="submit" />
            </div>
        );
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <Toolbar className="mb-4" start={actToolbarLeftTemplate} end={actToolbarRightTemplate}/>
            <div className="grid">
                <div className={`${commonStyle.leftMenu} col-3`}>
                    <DropdownInput 
                        formik={formik} 
                        paramName={"partner_id"} 
                        context={ctx.enums.partners.data}
                        onChange={(val) => formik.setFieldValue("partner_id", val)}
                        label={"Партнер"} />
                    <CalendarInput formik={formik} paramName={"act_date"} label={"Дата акту"} />
                    <CalendarInput formik={formik} paramName={"pay_due_date"} label={"Очікувана дата оплати"} />
                    <div className={`${commonStyle.formInput} mt-1`}>
                        {formik.values.commission_percent !== undefined &&
                            !isNaN(formik.values.commission_percent) && (
                                <label className={`${commonStyle.pseudoFloatLabel} ml-3`}>Комісія</label>
                            )}
                        <div className={`p-inputgroup flex-1 mt-1`}>
                            <SelectButton value={formik.values.comission_type} onChange={(e) => CheckAndChangeComissionType(e.value)} options={["%", "$"]} />
                            {formik.values.comission_type === "%" ?
                                <InputText
                                    placeholder="Комісія"
                                    value={formik.values.commission_percent}
                                    onChange={e => formik.setFieldValue("commission_percent", e.target.value)}
                                /> :
                                <InputText placeholder="Комісія" disabled />
                            }
                        </div>
                    </div>
                    {formik.values.comission_type === "$" && formik.values.commission.map((currencyAmount, index) => (
                        <div key={index} className={`${commonStyle.formInput} ${commonStyle.marginBottom}`}>
                            <div className="p-inputgroup flex-1">
                                <span className={`${commonStyle.currencySpan} p-inputgroup-addon`}>
                                    <Dropdown
                                        className={`${commonStyle.currencyDropDown} w-full`}
                                        value={currencyAmount.currency}
                                        onChange={e => handleParameterChange(index, e.value, "currency", "commission")}
                                        options={systemCurrencies}
                                    />
                                </span>
                                <InputText
                                    onChange={e => handleParameterChange(index, e.target.value, "amount", "commission")}
                                    name="amount"
                                    value={currencyAmount.amount}
                                    className={formik.errors.price && formik.touched.price ? 'p-invalid' : ''}
                                />
                                {formik.errors.price && formik.touched.price && (<small className={commonStyle.errorSmall}>{formik.errors.price}</small>)}
                            </div>
                        </div>))
                    }
                    <DiscountInput formik={formik} paramName={"discounts"} isDisabled={false} isMobile={isMobile}/>
                    <div className={commonStyle.checkBoxInput}>
                        <div className={`${commonStyle.checkboxStyle} p-inputgroup flex-1 md:w-22rem"`}>
                            <Checkbox
                                name="partner_is_payment_receiver"
                                onChange={(e) => { formik.setFieldValue('partner_is_payment_receiver', !formik.values.partner_is_payment_receiver) }}
                                checked={formik.values.partner_is_payment_receiver}
                            />
                            <label>Партнер отримує оплату</label>
                        </div>
                    </div>
                    <ActNumberWithAutogenerateInput formik={formik} />
                </div>
                <div className="col-9">
                    {formik.values.products.length > 0 && <DataTable value={formik.values.products} header={setTableHeader("Товари")} dataKey="id"  editMode="cell">
                        <Column field="quantity" header="Кількість" editor={(options) => numberEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} style={{ width: '5%' }} />
                        <Column field="external_product_name" header="Назва товару" editor={(options) => textEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} style={{ width: '65%' }} />
                        <Column field="external_product_price" header="Ціна за одиницю" 
                            editor={(options) => numberEditor(options, 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")}
                            body={(rowdata) => formatCurrency(rowdata.external_product_price, rowdata.external_product_currency)} style={{ width: '15%' }} />
                        <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(convertSumWithLatestCurrencyRate(rowdata.external_product_currency, rowdata.external_product_price), "UAH")} style={{ width: '15%' }} />
                    </DataTable>}
                    {formik.values.services.length > 0 && <DataTable value={formik.values.services} header={setTableHeader("Послуги")} editMode="cell" className="mt-5">
                        <Column field="description" header="Назва послуги" editor={(options) => textEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "services")} style={{ width: '70%' }} />
                        <Column field="price" header="Ціна за одиницю" 
                            editor={(options) => priceEditor(options, 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "services")}
                            body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} style={{ width: '15%' }} />
                        <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(convertSumWithLatestCurrencyRate(rowdata.currency, rowdata.price), "UAH")} style={{ width: '15%' }} />
                    </DataTable>}
                </div>
            </div>
        </form>)
}

export default ExternalActDetailsContent;